import { Component, Injector, ViewChild } from '@angular/core';
import type { OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { CustomerMessagesBasePage } from '@shared/pages';
import { CustomerMessagesComponent } from '@shared/components';
import type { CustomerMessageConfig, CustomerMessageData } from '@shared/components';

@Component({
    'selector': 'app-ticketCreated',
    'templateUrl': './ticketCreated.page.html',
    'styleUrls': ['./ticketCreated.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, CustomerMessagesComponent ]
})
export class TicketCreatedPage extends CustomerMessagesBasePage implements OnInit {
    @ViewChild(CustomerMessagesComponent) public customerMessagesComponent: CustomerMessagesComponent;
    
    public isDebugMode = false;
    public override vm: CustomerMessageData = {
        enabled: true,
        rawMessage: '',
        renderedMessage: '',
        message: '',
        enabledStr: '',
    };

    public config: CustomerMessageConfig = {
        enabledLabel: 'Send the ticket creation message.',
        disabledLabel: 'Do NOT send the ticket creation message.',
        messageLabel: 'Ticket Created Message',
        messagePreviewLabel: 'Message Appears As:',
        hasRangeSlider: false
    };

    public settings: any = {};
    public submitted = false;

    constructor( injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_TICKET_CREATED);
        super.setMessageNameEvent(this.Constants.EVENT_TICKET_CREATED);
        super.setDefaultMessage(this.Constants.SETTINGS_TICKET_CREATED_MSG);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        try {
            this.isDebugMode = (this.sessionService.isDebugMode());
            await this.uxHelperService.showSpinner();
            const settings = await this.settingsService.get();
            this.settings = settings || {};
            this.vm = this.settings.ticketCreated;
            if (!this.vm) {
                this.vm = {} as CustomerMessageData;
                this.vm.enabled = true;
                this.loadDefaultMessage();
            }

            // Initialize enabledStr based on enabled state
            this.vm.enabledStr = this.vm.enabled ? this.config.enabledLabel : this.config.disabledLabel;
            await this.uxHelperService.hideSpinner();
            this.initMoreMenu();
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    private initMoreMenu(): void {
        this.resetPopoverMenu();
        this.supplyCustomerMenuItems();
        this.pushPopoverMenuItem('Show Tour', 'show-ticket-created-tour');
        this.moreMenuItemClick(this.handleMenuItemClick);
    }

    public async onSaveClick(form?: NgForm): Promise<void> {
        this.submitted = true;
        
        // Get form from child component if not passed
        const formToValidate = form || this.customerMessagesComponent?.form;
        
        if (!formToValidate || !formToValidate.valid) {
            return;
        }

        try {
            await this.uxHelperService.showSpinner('Saving.');

            this.settings.ticketCreated = {
                'enabled': this.vm.enabled,
                'rawMessage': this.vm.rawMessage,
            };

            await this.settingsService.update(this.settings);
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Saved.');
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error:', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
            this.router.navigateByUrl('/managerSettings');
        }
    }
}
